// Initialize variables and check for undefined global variables
var activityEvents, scriptLoaded = false;
if (typeof __isPSA === 'undefined') var __isPSA = false;

// Define a MutationObserver if it's not already defined
if (typeof uLTS === 'undefined') {
  var uLTS = new MutationObserver(function (mutations) {
    // Mutation observer callback logic here
  });
  uLTS.observe(document.documentElement, { childList: true, subtree: true });
}

// Function to load JavaScript scripts
function loadJSScripts() {
  if (!scriptLoaded) {
    if (typeof uLTS !== 'undefined') uLTS.disconnect();
    if (typeof window.yett !== 'undefined') window.yett.unblock();

    scriptLoaded = true;

    // Replace data-src with src for iframes and scripts
    // document.querySelectorAll('iframe[data-src], script[data-src]').forEach(function (element) {
    //   var dataSrc = element.dataset.src;
    //   if (dataSrc != null) element.src = dataSrc;
    // });

    // Replace data-href with href for links
    document.querySelectorAll('link[data-href]').forEach(function (element) {
      var dataHref = element.dataset.href;
      if (dataHref != null) element.href = dataHref;
    });

    // Process and replace scripts marked for lazy loading
    document.querySelectorAll("script[type='text/lazyload']").forEach(function (element) {
      var script = document.createElement('script');
      Array.from(element.attributes).forEach(function (attr) {
        script.setAttribute(attr.name, attr.value);
      });
      script.type = 'text/javascript';
      script.innerHTML = element.innerHTML;
      element.parentNode.insertBefore(script, element);
      element.parentNode.removeChild(element);
    });

    // Dispatch custom events for lazy loaded scripts and bar injector
    document.dispatchEvent(new CustomEvent('asyncLazyLoad'));
    // setTimeout(function () {
    //   document.dispatchEvent(new CustomEvent('loadBarInjector'));
    // }, 10);
  }
}

// Set up activity events if __isPSA is true, otherwise load scripts immediately
if (__isPSA) {
  [
    'mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click', 'keypress', 'touchmove'
  ].forEach(function (event) {
    window.addEventListener(event, loadJSScripts, false);
  });
} else {
  loadJSScripts();
}
